import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ArtistDetailPresenter from './ArtistDetailPresenter';
import { useScrollTop } from '../../hooks';

import { ARTIST_DETAILS } from '../../artist';

const artistInitState = null; // []
const worksInitState = null;
const menuListInitState = [];
const WORKS_MENU_LABELS = {
  mv: 'MV',
};

const ArtistDetailContainer = () => {
  const { id } = useParams();

  const [artist, setArtist] = React.useState(artistInitState);
  const [works, setWorks] = React.useState(worksInitState);
  const [menuList, setMenuList] = React.useState(menuListInitState);

  const navigate = useNavigate();

  const onClickBack = () => navigate(-1);
  const onClickLink = (link) => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  React.useEffect(() => {
    const artistDetail = ARTIST_DETAILS[id];

    if (!artistDetail) {
      navigate('/artist', { replace: true });
      return;
    }

    setArtist(artistDetail);
    setWorks(artistDetail.works);

    const worksKeys = Object.keys(artistDetail.works).map(key =>
      WORKS_MENU_LABELS[key] || key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()
    );
    setMenuList(worksKeys);
  }, [id, navigate]);

  useScrollTop();

  if (!artist || !works) return null;
  
  return (
    <ArtistDetailPresenter 
      artist={artist} 
      works={works} 
      menuList={menuList} 
      onClickBack={onClickBack} 
      onClickLink={onClickLink}
    />
  );
};

export default ArtistDetailContainer;
